module.exports = __webpack_public_path__ + "static/media/desktopCharlieIcon.2afff202.svg";